import {BIModel} from './BIModel.js';

export class PointDeliveryBIModel extends BIModel {

    static eventName = 'click';

    #userId;
    #action;

    constructor(userId, action) {
        super(PointDeliveryBIModel.eventName, userId);

        this.#userId = userId;
        this.#action = action;
    }

    static createFromDomainEvent(userId, pointDeliveryEvent) {
        return new PointDeliveryBIModel(
            userId,
            pointDeliveryEvent.action
        );
    }

    get userId() {
        return this.#userId;
    }

    get action() {
        return this.#action;
    }

    get modelData() {
        return {
            action: this.action
        };
    }

}